// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"266":"e01ed3e6","453":"fb738f31"}[chunkId] + ".chunk.js";
};